import React from 'react';
import Dialog from '../../Dialog';
import { Divider } from '@mui/material';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import { FullSizeColumn, ColumnFlexBox, CenteredFlexBox } from '../../FlexBox';
import CaptionValue from '../../CaptionValue/CaptionValue';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';

const styles = {
  captionStyle: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  valueStyle: {
    fontSize: '30px',
    fontWeight: 'bold',
  },
  detailsCaption: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  detailsValue: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
};
const TargetProgressDetails = function TargetProgressDetails({
  title,
  open,
  onClose,
  data = {},
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      icon={<InfoOutlineRoundedIcon />}
      width="sm"
      fullWidth
    >
      <FullSizeColumn padding="16px">
        <CaptionValue
          caption="CALLS_MADE"
          value={data?.totalCount?.toString()}
          width="100%"
          direction="row"
          valueColor="#8D4EDA"
          captionStyle={styles.captionStyle}
          valueStyle={styles.valueStyle}
          gap="16px"
        />
        <CaptionValue
          caption="TOTAL_ANSWERED_CALLS"
          value={data?.answeredCount?.toString()}
          width="100%"
          direction="row"
          valueColor="success"
          captionStyle={styles.captionStyle}
          valueStyle={styles.valueStyle}
          gap="16px"
        />
        <Divider sx={{ margin: '16px 0px' }} />
        <CaptionValue
          caption="IN_TARGET"
          value={`${data?.answeredInTargetCount} / ${data?.totalInTargetCount}`}
          width="100%"
          direction="row"
          valueColor="primary"
          captionStyle={styles.captionStyle}
          valueStyle={styles.valueStyle}
          gap="16px"
        />
        <ColumnFlexBox padding="8px">
          {data?.detailsInTarget?.map(
            ({ sectionName, totalCount, answeredCount }) => (
              <CenteredFlexBox gap="16px" key={sectionName}>
                <FiberManualRecordRoundedIcon sx={{ fontSize: '8px' }} />
                <CaptionValue
                  caption={sectionName}
                  value={`${answeredCount} / ${totalCount}`}
                  width="100%"
                  direction="row"
                  captionStyle={styles.detailsCaption}
                  valueStyle={styles.detailsValue}
                  gap="16px"
                />
              </CenteredFlexBox>
            )
          )}
        </ColumnFlexBox>
        <Divider sx={{ margin: '16px 0px' }} />
        <CaptionValue
          caption="NOT_IN_TARGET"
          value={`${data?.answeredNotInTargetCount} / ${data?.totalNotInTargetCount}`}
          width="100%"
          direction="row"
          valueColor="primary"
          captionStyle={styles.captionStyle}
          valueStyle={styles.valueStyle}
          gap="16px"
        />
        <ColumnFlexBox padding="8px">
          {data?.detailsNotInTarget?.map(
            ({ sectionName, totalCount, answeredCount }) => (
              <CenteredFlexBox gap="16px" key={sectionName}>
                <FiberManualRecordRoundedIcon sx={{ fontSize: '8px' }} />
                <CaptionValue
                  key={sectionName}
                  caption={sectionName}
                  value={`${answeredCount} / ${totalCount}`}
                  width="100%"
                  direction="row"
                  captionStyle={styles.detailsCaption}
                  valueStyle={styles.detailsValue}
                  gap="16px"
                />
              </CenteredFlexBox>
            )
          )}
        </ColumnFlexBox>
      </FullSizeColumn>
    </Dialog>
  );
};

export default TargetProgressDetails;
